<template>

    <div class="layout__container">

        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20px">

                <div class="layout__position-left layout__width-100 layout__padding__top-20px">
                    <h2 class="text__align-center text__colour-teal layout__margin__top-10">Price Code Search</h2>
                </div>

                <div class="layout__padding-clear layout__width-70">
                    <PriceSearch v-bind:searchParams="searchParams" v-bind:prices="prices"
                                 v-bind:loading.fullscreen.lock="loading"></PriceSearch>
                </div>
                <div>
                    <el-table :data="prices.slice(this.start-1, this.end)" width="100%" v-on:row-click="viewPrices"
                              v-loading.fullscreen.lock="loading">
                        <el-table-column prop="code" label="Code" width="200">
                        </el-table-column>
                        <el-table-column prop="type" label="Type" width="140">
                        </el-table-column>
                        <el-table-column prop="status" label="Status" width="100">
                        </el-table-column>
                        <el-table-column prop="name" label="Name" width="500">
                        </el-table-column>
                        <el-table-column prop="press" label="Press" width="100">
                        </el-table-column>
                        <el-table-column prop="style" label="Style" width="100">
                        </el-table-column>
                        <el-table-column prop="isoSize" label="ISO" width="100">
                        </el-table-column>
                        <el-table-column prop="paperWeight" label="Stock" width="100">
                        </el-table-column>
                        <el-table-column prop="paperType" label="Type" width="100">
                        </el-table-column>
                        <el-table-column prop="finishing" label="Finishing" width="200">
                        </el-table-column>
                        <el-table-column prop="sellPrice" label="Sell Price" width="200">
                        </el-table-column>
                    </el-table>
                </div>

                <Pagination v-bind:orders="prices" v-bind:start="start" v-bind:end="end"
                            v-bind:pagination="pagination"></Pagination>

            </div>
        </div>
    </div>

</template>

<script>

    import PriceSearch from '../../components/search/PriceSearch.vue';
    import Pagination from "../../components/Pagination";

    export default {
        name: "price-codes",
        mixins: [],
        components: {
            PriceSearch,
            Pagination
        },
        data() {
            return {
                prices: [],
                loading: false,
                start: 1,
                end: 20,
                pagination: 20,
                searchParams: {
                    freetext: '',
                    status: 'ACTIVE'
                },
            }
        },
        created() {
            // todo this needs to make the call - the same defaults as
            this.isUserAuthorised();
        },
        methods: {
            viewPrices(price) {
                this.$router.push({
                    name: '/billing/prices/details',
                    params: {
                        price: price
                    },
                    query: {
                        code: price.code,
                    }
                })
            },
            createPriceCode() {
                this.$router.push({
                    name: '/billing/prices/create',
                })
            }
        }
    };
</script>